const comments = [
  {
    name: '光影猎人',
    text: '91电影真的是我每天必刷的网站，推荐的国产片质量很高，尤其是悬疑类型的推荐太对我的胃口了。每天都来看看有没有新片。',
    date: '3天前',
  },
  {
    name: '周末影迷小陈',
    text: '之前总为找好看的国产电影发愁，自从发现了91电影，再也没片荒过。分类很清晰，榜单也很有参考价值，强烈推荐！',
    date: '5天前',
  },
  {
    name: '文艺片爱好者',
    text: '文艺片的推荐非常用心，每一部都写了详细的推荐理由，不是随便糊弄的。国产文艺片确实有很多宝藏等你去发现。',
    date: '1周前',
  },
  {
    name: '科幻迷阿杰',
    text: '作为一个国产科幻迷，91电影的科幻专题做得太好了！从《流浪地球》到《星海征途》，推荐列表整理得很全。',
    date: '1周前',
  },
  {
    name: '电影学院小李',
    text: '作为一个学电影的，我觉得91电影的推荐质量在同行里算非常良心的。不搞标题党，不刷虚假数据，真实推荐值得尊重。',
    date: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            读者评论
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            听听91电影的用户们怎么说
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className={`bg-background-100 border border-background-200/70 rounded-xl p-5 ${
                idx === comments.length - 1 && comments.length % 2 !== 0
                  ? 'md:col-span-2 md:max-w-md md:mx-auto md:w-full'
                  : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-sm font-heading font-bold text-accent-700">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}